import { Services } from "../../api/Services";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CORPORATE_LOGO } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function Login() {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tokenurl = queryParams.get("token");
  

  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const id = window.localStorage.getItem("id");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (token && id) {
      navigate("/dashboard");
    }else if (tokenurl) {
      localStorage.setItem("token", tokenurl);
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState(null, "", url);
      userProfile();
    }
  }, [tokenurl, token]);

  const handleSubmit = async (e) => {
    setisLoading(true);
    e.preventDefault();
    try {
      const result = await Services.login(
        encodeURIComponent(email),
        encodeURIComponent(password)
      );

      if (result.status === 200) {
        localStorage.setItem("id", result?.data?.data?.id);
        localStorage.setItem("token", result?.data?.data?.api_token);
        localStorage.setItem("trainername", result?.data?.data?.name);
        localStorage.setItem("traineremail", result?.data?.data?.email);
        localStorage.setItem("trainerimage", result?.data?.data?.image);
        localStorage.setItem("trainerphone", result?.data?.data?.phone);
        localStorage.setItem("trainergender", result?.data?.data?.gender);
        localStorage.setItem("trainerjoined", result?.data?.data?.created_at);
        if(result?.data?.data?.corporate_identifier){
          localStorage.setItem("corporate_identifier	", result?.data?.data?.corporate_identifier);
        }
        navigate("/dashboard");
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  //api call for user profile data
  const userProfile = async (id) => {
    const prams = "";
    setisLoading(true);
    try {
      const result = await Services.getUserProfile(prams);

      if (result) {
        localStorage.setItem("id", result?.data?.data?.id);
        localStorage.setItem("trainername", result?.data?.data?.name);
        localStorage.setItem("traineremail", result?.data?.data?.email);
        localStorage.setItem("trainerimage", result?.data?.data?.image);
        localStorage.setItem("trainerphone", result?.data?.data?.phone);
        localStorage.setItem("trainergender", result?.data?.data?.gender);
        localStorage.setItem("trainerjoined", result?.data?.data?.created_at);
        if(result?.data?.data?.corporate_identifier){
          localStorage.setItem("corporate_identifier	", result?.data?.data?.corporate_identifier);
        }
        navigate("/dashboard");
      } else {
        // toast.error(result.data.message, {
        //   autoClose: 2000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   position: toast.POSITION.TOP_CENTER,
        // });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
      setisLoading(false);
    }
  };

  return (
    <div className="main-loging">
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}

      <div className="login-wrapper">
        <ToastContainer />
        <div className="home">
          <div className="logo-image">
            <img src={CORPORATE_LOGO} alt="" />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="home-form">
              <div className="form-group">
                <label>Enter your email</label>
                <input
                  type="text"
                  className="form-control input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group" style={{ position: 'relative' }}>
                <label>Enter your password</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    top: '30px',
                    right: '10px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  {showPassword ? <AiOutlineEyeInvisible size={22} /> : <AiOutlineEye size={22} />}
                </span>
              </div>
              <div className="login-buttons">
                <button type="submit" className="button">
                  submit
                </button>
                <Link to="/forgot" type="submit" className="button forgot">
                  Forgot password
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
